// `hidden` is the creator setting their own copy aside.
export const VISIBILITY_HIDDEN = 'hidden';
export const VISIBILITY_VISIBLE = '';

export function isItemHidden(item) {
  return item?.visibility === VISIBILITY_HIDDEN;
}
